import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import useGroupOptions from "./groupOptions";

function FilterTimeline({ filterOnView, initTimeline }) {
  const { t } = useTranslation();
  const groupOptions = useGroupOptions();

  // View Filter
  const [openViewFilter, setOpenViewFilter] = React.useState(false);
  const openMenuViewFilter = Boolean(openViewFilter);
  const handleViewFilterMenu = (event) => {
    setOpenViewFilter(event.currentTarget);
  };

  const handleViewFilterClose = () => {
    setOpenViewFilter(false);
  };

  const handleViewFilterItemClick = (filterOptionId) => {
    initTimeline(filterOptionId);
    handleViewFilterClose();
  };

  return (
    <div>
      <Button
        aria-label="choose a view filter"
        aria-controls="menu-timeline-filter-view"
        aria-haspopup="true"
        onClick={handleViewFilterMenu}
        size="small"
        endIcon={<ArrowDropDownIcon />}
        color="inherit"
      >
        <Typography variant="subtitle2" color="textSecondary">
          {t("timeline.groupBy")}{" "}
          {groupOptions.find((el) => el.id === filterOnView).title}
        </Typography>
      </Button>

      <Menu
        id="menu-timeline-filter-view"
        anchorEl={openViewFilter}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        disableScrollLock={true}
        open={openMenuViewFilter}
        onClose={handleViewFilterClose}
      >
        <Typography
          sx={{
            fontWeight: "500",
            fontSize: "0.8rem",
            paddingLeft: 2,
            paddingTop: 1,
            paddingBottom: 1,
          }}
        >
          {t("timeline.groupBy")}
        </Typography>

        {groupOptions.map((option) => (
          <MenuItem
            key={option.id}
            onClick={() => handleViewFilterItemClick(option.id)}
            selected={filterOnView === option.id}
          >
            <List dense={true} style={{ margin: 0, padding: 0 }}>
              <ListItem style={{ margin: 0, padding: 0 }}>
                <ListItemIcon sx={{ minWidth: "40px" }}>
                  {option.icon}
                </ListItemIcon>

                <ListItemText primary={option.title} />
              </ListItem>
            </List>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

FilterTimeline.propTypes = {
  viewFilterOption: PropTypes.number,
  setViewFilterOption: PropTypes.func,
};

export default FilterTimeline;
